import React from 'react';
import ModalAddMailing from '../ModalAddMailing';
import ModalComments from '../ModalComments';
import { format } from 'date-fns';
import { makeStyles } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { setDeleteUsers } from '../../../../store/mailing/thunk/setDeleteUsers';
import TableCasino from '../../../../../@casino/ui/table';
import { setGetMailingUsers } from '../../../../store/mailing/thunk/setGetMailingUsers';
import MailingUsersItem from '../MailingUsersItem';

const useStyles = makeStyles(() => ({
    btn: {
        padding: '3px 14px',
        borderRadius: 4,
        background: '#ffc324',
        color: '#141b33',
        cursor: 'pointer',
        border: 'none',
        fontSize: 16
    },
}))

const TabGeneral = ({ mailing, id }) => {
    const dispatch = useDispatch();
    const classes = useStyles();

    const [selected, setSelected] = React.useState(undefined);
    const [isOpenModalComments, setIsOpenModalComments] = React.useState(false);
    const [page, setPage] = React.useState(1);

    const users = useSelector((state) => state.mailing.users);


    const handleChangeModeComments = () => {
        setIsOpenModalComments(value => !value);
        setSelected(undefined)
    }

    return (
        <div>
            <div style={{
                padding: 10,
                background: '#1b2039',
                margin: '12px 0',
                display: 'flex',
                flexDirection: 'column',
                borderRadius: 8
            }}>
                <div style={{ display: 'flex', columnGap: 10, color: '#fff', fontSize: 16 }}>
                    <span>Дата рассылки</span> &mdash;
                    <span>{format(new Date(Number(mailing?.mailing_date_at || 0)), 'dd.mm.yyyy')}</span>
                </div>
                <div style={{ color: '#fff', fontSize: 16 }}>
                    <span>{mailing?.label}</span>
                </div>
                <div style={{ color: '#fff', fontSize: 16 }}>
                    <span>{mailing?.description}</span>
                </div>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', rowGap: 12 }}>
                {
                    users.data?.map((item) => (
                        <MailingUsersItem {...item} mailing={mailing} setSelected={setSelected} setIsOpenModalComments={setIsOpenModalComments} />
                    ))
                }
            </div>

            <div style={{ display: 'flex', justifyContent: 'center', marginTop: 20 }}>
                <button type="button" onClick={() => {
                    dispatch(setGetMailingUsers({
                        id,
                        page,
                        pageSize: (page + 1) * 25,
                    }))
                    setPage(page + 1)
                }} style={{
                    color: '#141b33',
                    cursor: 'pointer',
                    padding: '10px 0',
                    width: '100%',
                    background: '#ffc324',
                    borderRadius: '4px',
                    border: 'none',
                    outline: 'none'
                }}>Показать еще</button>
            </div>
            {
                isOpenModalComments && (
                    <ModalComments handleChangeModeComments={handleChangeModeComments} selected={selected} />
                )
            }
        </div>
    )
}

export default TabGeneral;